import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


    export const getWarehouseIoNo = (docsClassificationId,warehouseId,warehouseIOType,id=null,) =>
      http({
        baseURL: INVENTORYANDSALES_URL,
        url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.InventoryReceipt.nextNo,
        method: "get",
        headers: { "Accept-Language": "en" },
        params:{
          docsClassificationId,
          id,
          warehouseId,
          warehouseIOType
        }
      })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });

export const getSources = (warehouseId,pageNumber=1,pageSize=10 ) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.InventoryReceipt.SelectableList ,
    method: 'get',
params:{
    PageNumber: pageNumber,
    PageSize: pageSize,
    warehouseId
}

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
